import { render, staticRenderFns } from "./DispatcherDashboard.vue?vue&type=template&id=460751c5"
import script from "./DispatcherDashboard.vue?vue&type=script&lang=js"
export * from "./DispatcherDashboard.vue?vue&type=script&lang=js"
import style0 from "./DispatcherDashboard.vue?vue&type=style&index=0&id=460751c5&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports